import Accordion from './Accordion'
import DataBlock from './DataBlock'
import DataInfo from './DataInfo'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { FC } from 'react'

interface BlockContactProps {
  data: IBCKSKepalaSekolahEligibility['contact']
}

const BlockContact: FC<BlockContactProps> = ({ data }) => {
  return (
    <Accordion title="Kontak">
      <div className="space-y-4">
        <DataBlock label="Nomor handphone">
          {data?.noHp.value || data?.noHp.validation}
        </DataBlock>
        <DataBlock label="Email Belajar.id">
          {data?.emailBelajarId.value || data?.emailBelajarId.validation}
        </DataBlock>
        <DataBlock label="Email Pribadi">
          {data?.emailPribadi.value || data?.emailPribadi.validation}
        </DataBlock>

        <DataInfo name="operator Dapodik" />
      </div>
    </Accordion>
  )
}
export default BlockContact
